import React, { useCallback, useState } from "react";
import {
  HStack,
  Box,
  Icon,
  Text,
  InputGroup,
  InputLeftElement,
  Input,
  InputRightElement,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Select,
} from "@chakra-ui/react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaSearch, FaEye, FaRegCalendarAlt } from "react-icons/fa";
import Menu from "@/modules/Portaria/components/Menu";
import SimpleDatePicker from '@/components/DatePicker/index';

// import { MdMenu } from "react-icons/md";
// import { AiFillPrinter } from "react-icons/ai";
// import { useReactToPrint } from "react-to-print";

export interface HeaderSelectOption {
  label: string;
  value: string;
  onSelect: () => void;
}

interface HeaderProps {
  isMenuEnabled?: boolean;
  isEyeEnabled?: boolean;
  PrintEnabled?: boolean;
  isFilterVisible: boolean;
  onToggleFilter: () => void;
  onView?: (data: any) => void;
  printRef: React.RefObject<HTMLDivElement>;
  headers?: any;
  onHeadersChange?: (visibleHeaders: any) => void;
  title: string;
  searchTerm?: string;
  setSearchTerm?: (searchTerm: any) => void;
  filterComponent?: React.ReactNode;
  Calendar?: "period" | "day" | null;
  customActions?: React.ReactNode[];
  disabledInputSearch?: boolean;
  selectOptions?: HeaderSelectOption[];
  selectValue?: string;
}

const Header: React.FC<HeaderProps> = ({
  isMenuEnabled = false,
  isEyeEnabled = false,
  PrintEnabled = false,
  isFilterVisible = false,
  Calendar = null,
  onToggleFilter,
  onView,
  printRef,
  headers: visibleHeaders,
  onHeadersChange,
  title,
  searchTerm,
  setSearchTerm,
  filterComponent,
  customActions = [],
  disabledInputSearch = false,
  selectOptions,
  selectValue,
}) => {
  // const handlePrint = useReactToPrint({ content: () => printRef.current });

  const RenderMenu = useCallback(
    () => (
      <Box textAlign="center" >
        {visibleHeaders && onHeadersChange ? (
          <Menu headers={visibleHeaders} onFilter={onHeadersChange} >
            <Icon
              as={FaEye}
              boxSize={6}
              color={isEyeEnabled ? "#0F4F6D" : "gray.300"}
              cursor={isEyeEnabled ? "pointer" : "not-allowed"}
              onClick={isEyeEnabled ? onView : undefined}
            />
          </Menu>
        ) : (
          <Icon
            as={FaEye}
            boxSize={6}
            color="gray.300"
            cursor="not-allowed"
          />
        )}
      </Box>
    ),
    [visibleHeaders, onHeadersChange, isEyeEnabled]
  );

  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");

  const renderDatePicker = () => (
    <Popover>
      <PopoverTrigger>
        <Box>
          <Icon
            as={FaRegCalendarAlt}
            boxSize={6}
            cursor={Calendar ? "pointer" : "not-allowed"}
            color={Calendar ? "gray.800" : "gray.300"}
          />
        </Box>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverBody>
          {Calendar === "period" && (
            <HStack spacing={2}>
              <SimpleDatePicker onDateChange={(date) => setDataInicio(date)} />
              <SimpleDatePicker onDateChange={(date) => setDataFim(date)} />
            </HStack>
          )}
          {Calendar === "day" && (
            <SimpleDatePicker onDateChange={(date) => setDataInicio(date)} />
          )}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );

  return (
    <HStack alignItems={'center'} justify="space-between" border="1px" borderColor="#117baa" borderRadius="xl" p={2}>
      <HStack>
        <Icon boxSize={6} as={IoMdCheckmarkCircleOutline} color={'#117baa'} />
        <Text fontWeight="bold" fontSize="xl">
          {title}
        </Text>
      </HStack>

      <HStack spacing={4} align="center">
        <Box textAlign="center">
          <InputGroup size="sm">
            <InputLeftElement pointerEvents="none" color="gray.500" hidden={disabledInputSearch}>
              <Icon as={FaSearch} boxSize={4} />
            </InputLeftElement>

            <Input
              bg={'#d9d9d97e'}
              size="sm"
              rounded="2xl"
              letterSpacing={1.1}
              value={searchTerm}
              disabled={disabledInputSearch}
              placeholder="Pesquisar / Filtrar"
              visibility={disabledInputSearch ? "hidden" : "visible"}
              onChange={(e) => setSearchTerm && setSearchTerm(e.target.value)}
            />

            <InputRightElement>{filterComponent}</InputRightElement>
          </InputGroup>
        </Box>

        {selectOptions && selectOptions.length > 0 && (
          <Box textAlign="center">
            <Select
              size="sm"
              rounded="xl"
              bg="white"
              value={selectValue ?? selectOptions[0]?.value}
              onChange={(e) => {
                const option = selectOptions.find((opt) => opt.value === e.target.value);
                option?.onSelect();
              }}
            >
              {selectOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
          </Box>
        )}


        <RenderMenu />
        {Calendar && renderDatePicker()}

        {/* <Box display={'flex'} textAlign="center"  alignItems={'baseline'}>
          <Icon
            as={AiFillPrinter}
            boxSize={6}
            cursor={PrintEnabled ? "pointer" : "not-allowed"}
            onClick={PrintEnabled ? handlePrint : undefined}
            color={PrintEnabled ? "gray.800" : "gray.300"}
          />
        </Box> */}

        {customActions.map((action, index) => (
          <Box display={'flex'} textAlign="center" alignItems={'baseline'} key={index}>
            {action}
          </Box>
        ))}
      </HStack>
    </HStack>
  );
};

export default Header;
